export const articleCard = (theme) => ({
    container: {
        backgroundColor: theme.customPalette.neutralGr02,
        borderBottom: `4px solid ${theme.palette.primary.main}`,
        "&.isBig": {
            display: "flex",
            height: "100%",
        },
    },
    imageContainer: {
        height: 230,
        position: "relative",
        "&.isBig": {
            width: "50%",
            flexShrink: 0,
            height: "100%",
        },
    },
    bodyContainer: {
        padding: theme.spacing(2, 3),
        display: "flex",
        flexDirection: "column",
        "&.isBig": {
            padding: theme.spacing(6, 4),
        },
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    body: {
        lineHeight: 1.5,
        flexGrow: 1,
    },
    ctaContainer: {
        display: "flex",
        justifyContent: "flex-end",
        "&.isBig": {
            justifyContent: "flex-start",
        },
    },
    ctaBox: {
        paddingBottom: theme.spacing(1 / 2),
        borderBottom: `2px solid ${theme.palette.secondary.main}`,
        "&.isBig": {
            justifyContent: "flex-start",
        },
    },
    badgeBox: {
        position: "absolute",
        left: theme.spacing(3),
        bottom: 0,
        padding: theme.spacing(1 / 4, 1 / 2),
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
        "&.isBig": {
            position: "relative",
            left: "initial",
            width: "fit-content",
            marginBottom: theme.spacing(2),
        },
    },
    ribbonRoot: {},
    ribbon: {
        top: 42,
        left: -32,
        width: 170,
    },
});
